export default "__VITE_ASSET__ClV3mx4W__"